import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';

import { useHistory, useLocation } from 'react-router';

import useAuth from 'src/app/hooks/useAuth';
import { logout } from 'src/app/router/paths';

import Spinner from '../Elements/Spinner';

const Authenticated = ({ children }: PropsWithChildren<unknown>) => {
  const { isLoggedIn } = useAuth();
  const { replace } = useHistory();

  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    console.log({ 'Authenticated.isLoggedIn': isLoggedIn });
    if (isLoggedIn === false) {
      console.log(`Redirecting to logout from: ${pathname}.`);
      replace(logout.route, { referer: pathname, message: 'Your session has expired, please sign in.' });
    }
  }, [isLoggedIn, replace, pathname]);

  return isLoggedIn ? <>{children}</> : <Spinner centered />;
};

export default Authenticated;
